import { READ as ACTION_TYPE_READ } from './actionTypes';

export default { type: ACTION_TYPE_READ };
